import 'whatwg-fetch';
import config from '../../config/config';

const {
    API_SERVICERS_URL
} = config;

const consumerKey = process.env.REACT_APP_API_CONSUMER_KEY;
const consumerSecret = process.env.REACT_APP_API_CONSUMER_SECRET;

export const servicersApi = {
    fetchList: async (params = {}) => {
        const queryParams = new URLSearchParams({
            consumer_key: consumerKey,
            consumer_secret: consumerSecret,
            page: 1,
            per_page: 20,
            ...params,
        }).toString();

        const fetchOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        };

        const response = await fetch(
            `${API_SERVICERS_URL}?${queryParams}`,
            fetchOptions
        );

        if(!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const {
            page,
            total_users,
            total_pages,
            users,
        } = await response.json();

        return {
            data: users || [],
            total: total_users,
            totalPages: total_pages,
            page: page || 1,
        }
    }
}